import { ref } from "vue";

/**Состояние загрузки */
export const useLoading = () => {
  /**Идет ли загрузка */
  const isLoading = ref(false);
  /**Начать загрузку */
  const startLoading = () => {
    isLoading.value = true;
  };
  /**Завершить загрузку */
  const stopLoading = () => {
    isLoading.value = false;
  };

  return { isLoading, startLoading, stopLoading };
};
